import React, {useEffect, useState} from "react";
import { toast, ToastContainer } from 'react-toastify';
import msLogo from "../../img/MIND_MS_LOGO.svg";
import { useSearchParams } from "react-router-dom";
import EmailForm from "./EmailForm";
import EmailValidation from "./EmailValidation";
import SubscriptionForm from "./SubscriptionForm";
 
const SubscriptionRequest = () => {
  const [queryParameters, setQueryParameters] = useSearchParams();
  
  const [requestStep, setRequestStep] = useState(0);
  const [submitInfo, setSubmitInfo] = useState({ 
      clientName: '',
      customerFirstName: '',
      customerLastName: '',
      customerEmail: '',
      quantity: 1,
      subscriptionType: 'MONTHLY'
    });

    useEffect(() => {
      let step = queryParameters.get('requestStep')
      let customerEmail = queryParameters.get('email')  || ''
      console.log(customerEmail);
      
      if(step === null || step === '') {
        step=0;
      }
      setRequestStep(parseInt(step));
      setQueryParameters({
        email: customerEmail,
        requestStep: step
      });

      setSubmitInfo({
        ...submitInfo,
        customerEmail: customerEmail,
      });

    }, []);

    const handleEmailSubmitSuccess = (email) => {
      setSubmitInfo({
        ...submitInfo,
        customerEmail: email
      });
      setRequestStep(1);
      setQueryParameters({
        email: email,
        requestStep: 1
      });
    }

    function handleVerificationSuccess() {
      setRequestStep(2);
      setQueryParameters({
        email: submitInfo.customerEmail,
        requestStep: 2
      });
    }

    function handleFormState(step){
      switch(step) {
        case 0:
          return <EmailForm handleEmailSubmitSuccess={handleEmailSubmitSuccess} />

        case 1:
          return <EmailValidation email={submitInfo.customerEmail} handleVerificationSuccess={handleVerificationSuccess}/>

        case 2:
          return <SubscriptionForm  info={submitInfo}/>
        
        default:
          return <EmailForm handleEmailSubmitSuccess={handleEmailSubmitSuccess}/>
      }
    }


  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat bg-fixed pt-5" style={{ backgroundColor: '#f2f2f7' }}>
      <ToastContainer />
      <div className="relative transform overflow-hidden rounded-[15px] bg-254C5A text-left shadow-xl transition-all w-full max-w-lg mx-auto p-9">
        <div className="grid grid-cols-1 gap-4 justify-items-center">
          <div className="sm:col-span-1 flex justify-center ">
            <img src={msLogo} style={{height: '120px'}}></img>  
          </div>
        </div>
        {handleFormState(requestStep)}
      </div>

    </div>
  );
}

export default SubscriptionRequest;